import ibanLib from 'iban';
import { z } from 'zod';

import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import { requiredString } from '@/utils/zodUtils';

export const BankAccountFormSchema = (t: GetTextIdTranslationType) =>
  z
    .object({
      bankAccountNumber: requiredString(t),
    })
    .refine((data) => ibanLib.isValid(data.bankAccountNumber), {
      message: t('INVALID_IBAN'),
      path: ['bankAccountNumber'],
    });

export type BankAccountFormType = z.infer<ReturnType<typeof BankAccountFormSchema>>;
